export default __webpack_public_path__ + "static/media/permit-default.c97be2b1.svg";